import { useEffect, useState, useContext } from 'react';
import backArrow from '../../assets/img/backArrow.png';
import api from 'api';
import { get } from 'utils/fetch';
import { Select, Space, Spin, message, Switch } from 'antd';
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import { DeleteConfirmation } from 'components/DeleteConfirmation';
import { propertyToAddress } from 'utils/util';
import { isPhoneSize, isAdmin } from 'utils/util';
import { Email } from 'pages/Email/Email';
import { EmailResultBox } from 'pages/Email/EmailResultBox';
import { GlobalContext } from 'GlobalContext';
import {
    sumAllFormatUSD,
    sumCNYFormat,
    sumUSDFormat,
    USDollar,
} from 'utils/format';
import { CustomerManager } from './CustomerManager';
import { Files } from './InvestorInsertionTabs/Files';
import { InvestorPositionsTable } from './DRIInvestorPositions/InvestorPositionsTable';
import { Comments } from './Investor/Comments';
import { formatCurrency } from 'utils/format';
import { USD_TO_CNY } from 'utils/format';
import { InvestorReportEmail } from 'pages/Email/InvestorReportEmail';

export function InvestorInsertion(props) {
    // const { investor, accounts } = props
    const [messageApi, contextHolder] = message.useMessage();
    const {
        setManageRecordId,
        manageRecordId,
        setManageRecordTab,
        accessToken,
        refreshSession,
    } = useContext(GlobalContext);
    const [dirty, setDirty] = useState(false);
    const [saving, setSaving] = useState(false);
    const [accountsHeld, setAccountsHeld] = useState([]);
    const [creationErrorMessages, setCreationErrorMessages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [accountIdSelected, setAccountIdSelected] = useState([]);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [preferredFirstName, setPreferredFirstName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [address, setAddress] = useState('');
    const [USTaxResidentStatus, setUSTaxResidentStatus] = useState('');
    const [ssn, setSsn] = useState('');
    const [showDeletionBox, setShowDeletionBox] = useState(false);
    const [fundsByInvestor, setFundsByInvestor] = useState([]);
    const [companiesByInvestor, setCompaniesByInvestor] = useState([]);
    const [propertiesByInvestor, setPropertiesByInvestor] = useState([]);
    const [view, setView] = useState('investor');
    const [emailResponse, setEmailResponse] = useState('');
    const [investor, setInvestor] = useState(null);
    const [accounts, setAccounts] = useState([]);
    const [isDri, setIsDri] = useState(false);
    // accounts to be displayed in dropdown menu
    const [accountsDisplay, setAccountsDisplay] = useState([]);
    const [positionsByInvestor, setPositionsByInvestor] = useState([]);
    // account id -> account name
    const [accountIdToName, setAccountIdToName] = useState({});
    // account id -> [position]
    const [groupByAccount, setGroupByAccount] = useState({});
    const [editMode, setEditMode] = useState(
        manageRecordId === -1 ? true : false
    );
    const [viewSsn, setViewSsn] = useState(false);
    const [viewAddress, setViewAddress] = useState(false);
    const [DRIs, setDRIs] = useState([]);
    const [myDRI, setMyDRI] = useState(null);
    const [myDRIIdSelected, setMyDRIIdSelected] = useState(-1);
    const [myDRIDisplay, setMyDRIDisplay] = useState('');
    const [investorStatus, setInvestorStatus] = useState('');
    const [comments, setComments] = useState([]);
    // all investors for now
    const [referals, setReferals] = useState([]);
    const [myReferralId, setMyReferralId] = useState(null);

    function PositionTable(props) {
        const { currency, sumMethod } = props;
        function ByAccount(props) {
            const { id } = props;
            const curPositions = groupByAccount[id].filter(
                (position) =>
                    position.currency.toLowerCase() === currency.toLowerCase()
            );
            return (
                <>
                    {curPositions.length > 0 && (
                        <div
                            key={id}
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                            }}
                        >
                            <div
                                style={{
                                    width: '150px',
                                    alignContent: 'center',
                                    textAlign: 'center',
                                    border: '1px solid black',
                                    marginBottom: '2px',
                                    color: 'blue',
                                    textDecoration: 'underline',
                                    cursor: 'pointer',
                                }}
                                onClick={() => {
                                    setManageRecordId(id);
                                    setManageRecordTab('Investment Entities');
                                }}
                            >
                                {accountIdToName[id]}
                            </div>

                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    marginBottom: '2px',
                                }}
                            >
                                {curPositions.map((position, id) => (
                                    <div
                                        key={id}
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            border: '1px solid black',
                                            borderLeft: '0px',
                                            borderTop:
                                                id > 0
                                                    ? '0px'
                                                    : '1px solid black',
                                        }}
                                    >
                                        <div
                                            style={{
                                                width: '270px',
                                                display: 'flex',
                                                placeContent: 'center',
                                                alignItems: 'center',
                                                textAlign: 'center',
                                                flexDirection: 'column',
                                                color: 'blue',
                                                textDecoration: 'underline',
                                                cursor: 'pointer',
                                            }}
                                            onClick={() => {
                                                setManageRecordId(
                                                    position.fund_id
                                                );
                                                setManageRecordTab(
                                                    'Entities/Funds'
                                                );
                                            }}
                                        >
                                            {position.fund_name}
                                        </div>

                                        <div
                                            style={{
                                                width: '180px',
                                                display: 'flex',
                                                placeContent: 'center',
                                                alignItems: 'center',
                                                textAlign: 'center',
                                            }}
                                        >
                                            {formatCurrency(
                                                position.amount,
                                                position.currency
                                            )}
                                        </div>

                                        <div
                                            style={{
                                                width: '150px',
                                                display: 'flex',
                                                placeContent: 'center',
                                                alignItems: 'center',
                                                textAlign: 'center',
                                            }}
                                        >
                                            {formatCurrency(
                                                position.account_balance,
                                                position.currency
                                            )}
                                        </div>

                                        <div
                                            style={{
                                                width: '150px',
                                                display: 'flex',
                                                placeContent: 'center',
                                                alignItems: 'center',
                                                textAlign: 'center',
                                            }}
                                        >
                                            {position.funding_receipt_date.slice(
                                                0,
                                                10
                                            )}
                                        </div>

                                        <div
                                            style={{
                                                width: '150px',
                                                display: 'flex',
                                                placeContent: 'center',
                                                alignItems: 'center',
                                                textAlign: 'center',
                                            }}
                                        >
                                            {formatCurrency(
                                                position.interest_received,
                                                position.currency
                                            )}
                                        </div>

                                        <div
                                            style={{
                                                width: '150px',
                                                display: 'flex',
                                                placeContent: 'center',
                                                alignItems: 'center',
                                                textAlign: 'center',
                                            }}
                                        >
                                            {formatCurrency(
                                                position.principal_returned,
                                                position.currency
                                            )}
                                        </div>

                                        <div
                                            style={{
                                                width: '50px',
                                                display: 'flex',
                                                placeContent: 'center',
                                                alignItems: 'center',
                                                textAlign: 'center',
                                            }}
                                        >
                                            <button
                                                style={{
                                                    background: 'rgb(17 32 86)',
                                                    color: 'white',
                                                    height: '30px',
                                                    borderRadius: '10px',
                                                    cursor: 'pointer',
                                                }}
                                                onClick={() => {
                                                    setManageRecordId(
                                                        position.investment_id
                                                    );
                                                    setManageRecordTab(
                                                        'Positions'
                                                    );
                                                }}
                                            >
                                                Detail
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </>
            );
        }
        return (
            <div style={{ margin: '20px 0' }}>
                <div>{currency.toUpperCase()} Summary</div>
                <div
                    style={{
                        overflowX: 'scroll',
                        overflow: 'auto',
                        scrollbarWidth: 'auto',
                    }}
                >
                    <div style={{ width: '1250px' }}>
                        <div
                            style={{
                                display: 'flex',
                                fontSize: '17px',
                            }}
                        >
                            <div
                                style={{
                                    width: '150px',
                                    display: 'flex',
                                    placeContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                }}
                            >
                                Investment Entity
                            </div>

                            <div
                                style={{
                                    width: '270px',
                                    display: 'flex',
                                    placeContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                }}
                            >
                                Fund
                            </div>

                            <div
                                style={{
                                    width: '180px',
                                    display: 'flex',
                                    placeContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                }}
                            >
                                Commitment Number
                            </div>

                            <div
                                style={{
                                    width: '150px',
                                    display: 'flex',
                                    placeContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                }}
                            >
                                Equity Balance
                            </div>

                            <div
                                style={{
                                    width: '150px',
                                    display: 'flex',
                                    placeContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                }}
                            >
                                Capital in Date
                            </div>

                            <div
                                style={{
                                    width: '150px',
                                    display: 'flex',
                                    placeContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                }}
                            >
                                Distribute Interest
                            </div>

                            <div
                                style={{
                                    width: '150px',
                                    display: 'flex',
                                    placeContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                }}
                            >
                                Principal Return
                            </div>
                        </div>
                        {Object.keys(groupByAccount).map((id) => (
                            <ByAccount key={id} id={id} />
                        ))}
                        <div
                            style={{
                                display: 'flex',
                                border: '1px solid black',
                            }}
                        >
                            <div
                                style={{
                                    width: '150px',
                                    display: 'flex',
                                    placeContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                }}
                            >
                                Sum
                            </div>

                            <div
                                style={{
                                    width: '270px',
                                    display: 'flex',
                                    placeContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                }}
                            ></div>

                            <div
                                style={{
                                    width: '180px',
                                    display: 'flex',
                                    placeContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                }}
                            >
                                {sumMethod(positionsByInvestor, 'amount')}
                            </div>

                            <div
                                style={{
                                    width: '150px',
                                    display: 'flex',
                                    placeContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                }}
                            >
                                {sumMethod(
                                    positionsByInvestor,
                                    'account_balance'
                                )}
                            </div>

                            <div
                                style={{
                                    width: '150px',
                                    display: 'flex',
                                    placeContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                }}
                            ></div>

                            <div
                                style={{
                                    width: '150px',
                                    display: 'flex',
                                    placeContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                }}
                            >
                                {sumMethod(
                                    positionsByInvestor,
                                    'interest_received'
                                )}
                            </div>

                            <div
                                style={{
                                    width: '150px',
                                    display: 'flex',
                                    placeContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                }}
                            >
                                {sumMethod(
                                    positionsByInvestor,
                                    'principal_returned'
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    function Summary(props) {
        const { sumMethod } = props;
        return (
            <div style={{ margin: '20px 0' }}>
                <div>Summary</div>
                <div
                    style={{
                        overflowX: 'scroll',
                        overflow: 'auto',
                        scrollbarWidth: 'auto',
                    }}
                >
                    <div style={{ width: '780px' }}>
                        <div
                            style={{
                                display: 'flex',
                                fontSize: '17px',
                            }}
                        >
                            <div
                                style={{
                                    width: '150px',
                                    display: 'flex',
                                    placeContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                }}
                            >
                                Investment Entity
                            </div>

                            <div
                                style={{
                                    width: '180px',
                                    display: 'flex',
                                    placeContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                }}
                            >
                                Commitment Number
                            </div>

                            <div
                                style={{
                                    width: '150px',
                                    display: 'flex',
                                    placeContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                }}
                            >
                                Equity Balance
                            </div>

                            <div
                                style={{
                                    width: '150px',
                                    display: 'flex',
                                    placeContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                }}
                            >
                                Distribute Interest
                            </div>

                            <div
                                style={{
                                    width: '150px',
                                    display: 'flex',
                                    placeContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                }}
                            >
                                Principal Return
                            </div>
                        </div>

                        <div
                            style={{
                                display: 'flex',
                                border: '1px solid black',
                            }}
                        >
                            <div
                                style={{
                                    width: '150px',
                                    display: 'flex',
                                    placeContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                }}
                            >
                                Summary
                            </div>

                            <div
                                style={{
                                    width: '180px',
                                    display: 'flex',
                                    placeContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                }}
                            >
                                {sumMethod(positionsByInvestor, 'amount')}
                            </div>

                            <div
                                style={{
                                    width: '150px',
                                    display: 'flex',
                                    placeContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                }}
                            >
                                {sumMethod(
                                    positionsByInvestor,
                                    'account_balance'
                                )}
                            </div>

                            <div
                                style={{
                                    width: '150px',
                                    display: 'flex',
                                    placeContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                }}
                            >
                                {sumMethod(
                                    positionsByInvestor,
                                    'interest_received'
                                )}
                            </div>

                            <div
                                style={{
                                    width: '150px',
                                    display: 'flex',
                                    placeContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                }}
                            >
                                {sumMethod(
                                    positionsByInvestor,
                                    'principal_returned'
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // console.log(myDRI)
    const displayErrorMessage = (message) => {
        messageApi.open({
            type: 'error',
            content: message,
        });
    };

    var account2id = {};
    for (const account of accounts) {
        account2id[account.account_name] = account.id;
    }

    var driName2id = { '': -1 };
    for (const dri of DRIs) {
        driName2id[dri.legal_name] = dri.id;
    }

    const entryStyle = isPhoneSize()
        ? {
              margin: '20px',
              fontSize: '20px',
          }
        : {
              margin: '20px',
              fontSize: '20px',
              // display: "flex"
          };

    const commentCardStyle = {
        backgroundColor: '#f9fafb',
        padding: '16px',
        borderRadius: '4px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        marginBottom: '16px',
    };

    const commentHeaderStyle = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: '8px',
    };

    const authorStyle = {
        fontWeight: 'bold',
        marginBottom: '4px',
    };

    const timestampStyle = {
        fontSize: '14px',
        color: '#666',
    };

    const commentTextStyle = {
        fontSize: '16px',
        lineHeight: '1.5',
    };

    const inputStyle = {
        border: '0',
        outline: 'none',
        borderBottom: '1px solid black',
        fontSize: '20px',
        background: 'transparent',
    };

    function canSubmit() {
        var invalidFields = [];
        if (firstName.trim().length === 0) {
            invalidFields.push('Please fill in first name.');
        }
        if (lastName.trim().length === 0) {
            invalidFields.push('Please fill in last name.');
        }
        if (email.trim().length === 0) {
            invalidFields.push('Please fill in phone.');
        }
        if (phone.trim().length === 0) {
            invalidFields.push('Please fill in phone.');
        }

        setCreationErrorMessages(invalidFields);
        return invalidFields.length === 0;
    }

    async function fetchPotentialReferrals() {
        await get(
            api.manager.potentialReferrals,
            setReferals,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
    }

    async function fetchComments(id) {
        await get(
            api.manager.investorComments(id),
            setComments,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
    }

    async function fetchInvestmentsByInvestor(id) {
        await get(
            api.manager.fundsByInvestor(id),
            setFundsByInvestor,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
    }

    async function fetchCompaniesByInvestor(id) {
        await get(
            api.manager.companiesByInvestor(id),
            setCompaniesByInvestor,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
    }

    async function fetchPropertiesByInvestor(id) {
        await get(
            api.manager.propertiesByInvestor(id),
            setPropertiesByInvestor,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
    }

    async function fetchAccounts() {
        await get(
            api.manager.accounts,
            setAccounts,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
    }

    async function fetchInvestor(id) {
        await get(
            api.manager.investor(id),
            setInvestor,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
    }

    async function fetchPositionsByInvestor(id) {
        await get(
            api.manager.positionsByInvestor(id),
            setPositionsByInvestor,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
    }

    async function fetchAccountsByInvestor(id) {
        await get(
            api.manager.accountsByInvestor(id),
            setAccountsHeld,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
        setLoading(false);
    }

    async function fetchMyDRI(id) {
        await get(
            api.manager.myDRI(id),
            setMyDRI,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
    }

    async function fetchDRIs() {
        await get(
            api.manager.DRIs,
            setDRIs,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
    }

    useEffect(() => {
        setAccountIdSelected(accountsHeld.map((account) => account.id));
        setAccountsDisplay(accountsHeld.map((account) => account.id));
    }, [accountsHeld]);

    useEffect(() => {
        if (myDRI) {
            setMyDRIIdSelected(myDRI.id);
            setMyDRIDisplay(myDRI.legal_name);
        }
    }, [myDRI]);

    useEffect(() => {
        // get account id -> account name map,
        // group investment by account
        var accountIdToName = {};
        for (const position of positionsByInvestor) {
            accountIdToName[position.account_id] = position.account_name;
        }
        setAccountIdToName(accountIdToName);

        var groupByAccount = {};
        for (const position of positionsByInvestor) {
            if (!groupByAccount[position.account_id]) {
                groupByAccount[position.account_id] = [];
            }
            groupByAccount[position.account_id].push(position);
        }
        setGroupByAccount(groupByAccount);
    }, [positionsByInvestor]);

    useEffect(() => {
        //console.log("Investor Insertion Rendered.")
        fetchDRIs();
        fetchPotentialReferrals();
        if (manageRecordId <= 0) {
            setLoading(false);
            return;
        }
        if (investor === null) {
            return;
        }
        restore();
        fetchComments(investor.id);
        fetchMyDRI(investor.id);
        fetchInvestmentsByInvestor(investor.id);
        fetchCompaniesByInvestor(investor.id);
        fetchPropertiesByInvestor(investor.id);
        fetchPositionsByInvestor(investor.id);
        fetchAccountsByInvestor(investor.id);
    }, [investor, view]);

    function restore() {
        if (investor === null) {
            return;
        }
        setFirstName(investor.first_name === null ? '' : investor.first_name);
        setLastName(investor.last_name === null ? '' : investor.last_name);
        setEmail(investor.email === null ? '' : investor.email);
        setPhone(investor.phone === null ? '' : investor.phone);
        setAddress(investor.address === null ? '' : investor.address);
        setSsn(investor.ssn_encrypted === null ? '' : investor.ssn_encrypted);
        setUSTaxResidentStatus(
            investor.us_tax_resident_status === null
                ? ''
                : investor.us_tax_resident_status
        );
        setIsDri(investor.is_dri === null ? false : investor.is_dri);
        setInvestorStatus(
            investor.investor_status === null ? '' : investor.investor_status
        );
        setMyReferralId(investor.referral_id);
        setPreferredFirstName(investor.preferred_first_name);
    }

    // console.log("positionsByInvestor", positionsByInvestor)

    useEffect(() => {
        if (isAdmin()) {
            fetchAccounts();
        }
        if (manageRecordId > 0) {
            fetchInvestor(manageRecordId);
        }
    }, []);
    // console.log(manageRecordId)
    // console.log(accountsHeld.map(account => account.account_name))

    function ssnChanged() {
        if (!investor) return true;
        if (investor.ssn_encrypted !== ssn) return true;
        if (investor.ssn_encrypted === ssn) return false;
    }

    async function saveInvestor() {
        //console.log(canSubmit())
        if (canSubmit() === false) {
            return;
        }
        //console.log("idDirty", dirty)
        if (dirty === false) {
            // setManageRecordId(0)
            return;
        }
        setSaving(true);
        setFirstName(firstName.trim());
        setLastName(lastName.trim());
        setPreferredFirstName(
            preferredFirstName ? preferredFirstName.trim() : preferredFirstName
        );
        setEmail(email.trim());
        setPhone(phone.trim());
        setSsn(ssn.trim());
        setAddress(address.trim());
        // account id held
        const accountIdsHeld =
            accounts.length === 0
                ? []
                : accountsHeld.map((account) => account.id);
        // newly added account idx (selected but not previously held)
        const addedAccountIds =
            accountIdSelected.length === 0
                ? []
                : accountIdSelected.filter(
                      (id) => !accountIdsHeld.includes(id)
                  );
        // removed property idx (previously invested but not selected)
        const removedAccountIds =
            accountIdsHeld.length === 0
                ? []
                : accountIdsHeld.filter(
                      (id) => !accountIdSelected.includes(id)
                  );
        // console.log(accountIdsHeld, addedAccountIds, removedAccountIds)
        const option = {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`,
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: JSON.stringify({
                firstName,
                lastName,
                preferredFirstName,
                email,
                phone,
                addedAccountIds,
                removedAccountIds,
                ssn,
                address,
                USTaxResidentStatus,
                isDri,
                preDriId: myDRI ? myDRI.id : -1,
                myDRIIdSelected,
                investorStatus,
                ssnChanged: ssnChanged(),
                myReferralId,
            }),
        };
        var res = null;
        setLoading(true);
        if (investor === null) {
            res = await fetch(api.manager.investors, option);
        } else {
            res = await fetch(api.manager.investor(investor.id), option);
        }
        if (!res) {
            setLoading(false);
            return;
        }
        const newInvestorId = (await res.json()).data;
        refreshSession();
        // setManageRecordId(0)
        setManageRecordId(newInvestorId);
        fetchInvestor(newInvestorId);
        setSaving(false);
        setEditMode(false);
    }
    // console.log(accountsHeld)
    const handleChange = (selectedAccounts) => {
        setDirty(true);
        setAccountIdSelected(selectedAccounts);
        // setAccountsDisplay(
        //     selectedAccounts.map((accountId) => {
        //         return accounts.find(
        //             (account) => account.id === parseInt(accountId)
        //         ).account_name;
        //     })
        // );
    };

    const handleMyDRIChange = (driId) => {
        setDirty(true);
        setMyDRIIdSelected(driId);
        // setMyDRIDisplay(dri)
    };
    const selectionOptions = accounts
        .sort((a, b) => a.account_name.localeCompare(b.account_name))
        .map((account) => {
            return {
                label: account.account_name,
                value: account.id,
                desc: account.account_name,
            };
        });

    const driSelectionOptions = [
        {
            label: '',
            value: -1,
            desc: '',
        },
        ...DRIs.map((DRI) => {
            return {
                label: DRI.legal_name,
                value: DRI.id,
                desc: DRI.legal_name,
            };
        }),
    ];

    function deleteInvestor() {
        if (accountsHeld.length > 0) {
            setCreationErrorMessages([
                ...accountsHeld.map((account) => {
                    return `Current investor is holding ${account.account_name}.`;
                }),
            ]);
            return;
        }
        setShowDeletionBox(true);
    }

    // called by DeleteConfirmation component to delete current record
    async function deletionCallback() {
        const options = {
            method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`,
            },
            // body
        };
        const result = await fetch(api.manager.investor(investor.id), options);
        refreshSession();
        const data = await result.json();
        setManageRecordId(0);
    }

    function getEmailResBGColor() {
        if (emailResponse === 'Email sent successfully') {
            return '#007BFF';
        } else if (emailResponse === 'Sending...') {
            return '#4A90E2';
        }
        return '#FF4C4C';
    }

    function getEmailBoxShadow() {
        if (emailResponse === 'Email sent successfully') {
            return '0 4px 8px rgba(0, 123, 255, 0.3)';
        } else if (emailResponse === 'Sending...') {
            return '0 4px 8px #3E7BB1';
        }
        return '0 4px 8px rgba(255, 76, 76, 0.3)';
    }

    function handleIsDRIStatusSwitchChange(status) {
        setDirty(true);
        setIsDri(status);
    }

    function referralToText(ref) {
        return `${ref.legal_name} (${ref.email})`;
    }

    return (
        <>
            {loading && (
                <div style={{ marginTop: '30px', textAlign: 'center' }}>
                    <Spin />
                </div>
            )}

            {!loading && view === 'email' && (
                <Email
                    setView={setView}
                    emailPassed={[investor.email]}
                    fromView="investor"
                    setEmailResponse={setEmailResponse}
                />
            )}

            {!loading && view === 'customers' && (
                <CustomerManager setView={setView} />
            )}

            {!loading && view === 'files' && <Files setView={setView} />}

            {!loading && view === 'comments' && <Comments setView={setView} />}

            {!loading && view === 'report' && (
                <InvestorReportEmail
                    setView={setView}
                    setEmailResponse={setEmailResponse}
                    investorId={manageRecordId}
                />
            )}

            {!loading && view === 'investor' && (
                <div>
                    {
                        // emailResponse.length > 0 && <div style={{
                        //     position: "fixed",       /* Fix the div in place */
                        //     top: "100px",           /* 100px from the top */
                        //     right: "0",             /* Align to the right */
                        //     width: "200px",         /* Optional width */
                        //     backgroundColor: getEmailResBGColor(), /* Success Blue */
                        //     color: "white",              /* White text for contrast */
                        //     padding: "10px",
                        //     borderRadius: "5px",
                        //     boxShadow: getEmailBoxShadow(), /* Shadow for success */
                        //     transition: "opacity 1s ease, transform 1s ease" /* Transition for smoothness */
                        // }}>
                        //     {emailResponse}
                        // </div>
                    }

                    <EmailResultBox emailResponse={emailResponse} />

                    {investor !== null && showDeletionBox && (
                        <DeleteConfirmation
                            title={`Investor: ${investor.legal_name}`}
                            setShowDeletionBox={setShowDeletionBox}
                            deletionCallback={deletionCallback}
                        />
                    )}

                    <div
                        style={{
                            margin: '20px',
                            display: 'flex',
                            justifyContent: 'space-between',
                        }}
                    >
                        <img
                            style={{
                                width: '15px',
                                height: '20px',
                                cursor: 'pointer',
                            }}
                            src={backArrow}
                            onClick={() => setManageRecordId(0)}
                        ></img>

                        {manageRecordId > 0 && (
                            <div style={{ display: 'flex' }}>
                                {isDri && (
                                    <button
                                        style={{
                                            height: '30px',
                                            width: '85px',
                                            borderRadius: '30px',
                                            background: 'rgb(17 32 86)',
                                            color: 'white',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            placeContent: 'center',
                                        }}
                                        onClick={(e) => setView('customers')}
                                    >
                                        Customers
                                    </button>
                                )}

                                <button
                                    style={{
                                        marginLeft: '10px',
                                        height: '30px',
                                        width: '80px',
                                        borderRadius: '30px',
                                        background: 'rgb(17 32 86)',
                                        color: 'white',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        placeContent: 'center',
                                    }}
                                    onClick={(e) => setView('report')}
                                >
                                    Summary
                                </button>

                                <button
                                    style={{
                                        marginLeft: '10px',
                                        height: '30px',
                                        width: '80px',
                                        borderRadius: '30px',
                                        background: 'rgb(17 32 86)',
                                        color: 'white',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        placeContent: 'center',
                                    }}
                                    onClick={(e) => setView('comments')}
                                >
                                    Comments
                                </button>

                                <button
                                    style={{
                                        marginLeft: '10px',
                                        height: '30px',
                                        width: '60px',
                                        borderRadius: '30px',
                                        background: 'rgb(17 32 86)',
                                        color: 'white',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        placeContent: 'center',
                                    }}
                                    onClick={(e) => setView('files')}
                                >
                                    Files
                                </button>
                            </div>
                        )}
                    </div>

                    {isAdmin() && manageRecordId > 0 && (
                        <div
                            onClick={(e) => {
                                if (editMode) {
                                    restore();
                                }
                                setEditMode(!editMode);
                            }}
                            style={{
                                width: 'fit-content',
                                color: 'blue',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                                marginLeft: '20px',
                            }}
                        >
                            {editMode ? 'Restore' : 'Edit'}
                        </div>
                    )}

                    {creationErrorMessages.map((message, idx) => {
                        return (
                            <div
                                key={idx}
                                style={{ color: 'red', marginLeft: '20px' }}
                            >
                                {message}
                            </div>
                        );
                    })}

                    <div
                        style={
                            isPhoneSize()
                                ? { height: 'calc(100vh - 281px)' }
                                : { height: 'calc(100vh - 125px)' }
                        }
                    >
                        <div style={{ height: '100%', overflowY: 'auto' }}>
                            {manageRecordId > 0 && (
                                <div
                                    style={
                                        isPhoneSize()
                                            ? entryStyle
                                            : { ...entryStyle, display: 'flex' }
                                    }
                                >
                                    <div>Investor ID: {manageRecordId}</div>
                                </div>
                            )}

                            <div
                                style={
                                    isPhoneSize()
                                        ? entryStyle
                                        : { ...entryStyle, display: 'flex' }
                                }
                            >
                                {editMode && (
                                    <>
                                        <div>
                                            Legal First Name
                                            <span style={{ color: 'red' }}>
                                                *
                                            </span>
                                            :
                                        </div>{' '}
                                        <input
                                            style={inputStyle}
                                            value={firstName}
                                            onInput={(e) => {
                                                setFirstName(e.target.value);
                                                setDirty(true);
                                            }}
                                        ></input>
                                    </>
                                )}

                                {!editMode && (
                                    <div>Legal First Name: {firstName}</div>
                                )}
                            </div>

                            <div
                                style={
                                    isPhoneSize()
                                        ? entryStyle
                                        : { ...entryStyle, display: 'flex' }
                                }
                            >
                                {editMode && (
                                    <>
                                        <div>Preferred First Name:</div>{' '}
                                        <input
                                            style={inputStyle}
                                            value={preferredFirstName || ''}
                                            onInput={(e) => {
                                                setPreferredFirstName(
                                                    e.target.value
                                                );
                                                setDirty(true);
                                            }}
                                        ></input>
                                    </>
                                )}

                                {!editMode && (
                                    <div>
                                        Preferred First Name:{' '}
                                        {preferredFirstName}
                                    </div>
                                )}
                            </div>

                            <div
                                style={
                                    isPhoneSize()
                                        ? entryStyle
                                        : { ...entryStyle, display: 'flex' }
                                }
                            >
                                {editMode && (
                                    <>
                                        <div>
                                            Last Name
                                            <span style={{ color: 'red' }}>
                                                *
                                            </span>
                                            :
                                        </div>{' '}
                                        <input
                                            style={inputStyle}
                                            value={lastName}
                                            onInput={(e) => {
                                                setLastName(e.target.value);
                                                setDirty(true);
                                            }}
                                        ></input>
                                    </>
                                )}

                                {!editMode && <div>Last Name: {lastName}</div>}
                            </div>

                            <div
                                style={
                                    isPhoneSize()
                                        ? entryStyle
                                        : { ...entryStyle, display: 'flex' }
                                }
                            >
                                {editMode && (
                                    <>
                                        <div>
                                            Email
                                            <span style={{ color: 'red' }}>
                                                *
                                            </span>
                                            :
                                        </div>{' '}
                                        <input
                                            style={inputStyle}
                                            value={email}
                                            onInput={(e) => {
                                                setEmail(e.target.value);
                                                setDirty(true);
                                            }}
                                        ></input>
                                    </>
                                )}

                                {!editMode && <div>Email: {email}</div>}
                            </div>

                            <div
                                style={
                                    isPhoneSize()
                                        ? entryStyle
                                        : { ...entryStyle, display: 'flex' }
                                }
                            >
                                {editMode && (
                                    <>
                                        <div>
                                            Phone Number
                                            <span style={{ color: 'red' }}>
                                                *
                                            </span>
                                            :
                                        </div>{' '}
                                        <input
                                            style={inputStyle}
                                            value={phone}
                                            onInput={(e) => {
                                                setPhone(e.target.value);
                                                setDirty(true);
                                            }}
                                        ></input>
                                    </>
                                )}

                                {!editMode && <div>Phone Number: {phone}</div>}
                            </div>

                            <div
                                style={
                                    isPhoneSize()
                                        ? entryStyle
                                        : { ...entryStyle, display: 'flex' }
                                }
                            >
                                {editMode && (
                                    <>
                                        <div>SSN:</div>{' '}
                                        <input
                                            style={inputStyle}
                                            value={ssn}
                                            onInput={(e) => {
                                                setSsn(e.target.value);
                                                setDirty(true);
                                            }}
                                        ></input>
                                    </>
                                )}
                                {!editMode && viewSsn && (
                                    <>
                                        <div>SSN: {ssn}</div>

                                        <EyeOutlined
                                            style={{
                                                color: 'blue',
                                                marginLeft: '10px',
                                            }}
                                            onClick={(e) => setViewSsn(false)}
                                        />
                                    </>
                                )}

                                {!editMode && !viewSsn && (
                                    <>
                                        <div>SSN: {'*'.repeat(ssn.length)}</div>
                                        {isAdmin() && (
                                            <EyeInvisibleOutlined
                                                style={{
                                                    color: 'blue',
                                                    marginLeft: '10px',
                                                }}
                                                onClick={(e) =>
                                                    setViewSsn(true)
                                                }
                                            />
                                        )}
                                    </>
                                )}
                            </div>

                            <div style={entryStyle}>
                                {editMode && (
                                    <>
                                        <div
                                            style={
                                                isPhoneSize()
                                                    ? {
                                                          display: 'flex',
                                                          flexDirection:
                                                              'column',
                                                      }
                                                    : {
                                                          display: 'flex',
                                                          flexDirection: 'row',
                                                      }
                                            }
                                        >
                                            <div>Investor Status: </div>
                                            <span>
                                                <Select
                                                    // mode="multiple"
                                                    style={
                                                        isPhoneSize()
                                                            ? {
                                                                  width: '300px',
                                                              }
                                                            : {
                                                                  width: '300px',
                                                                  marginLeft:
                                                                      '5px',
                                                              }
                                                    }
                                                    placeholder="select status"
                                                    value={investorStatus}
                                                    onChange={(status) => {
                                                        setDirty(true);
                                                        setInvestorStatus(
                                                            status
                                                        );
                                                    }}
                                                    options={[
                                                        'Invested',
                                                        'Uninvested',
                                                        'Quitted',
                                                        'Potential Investor',
                                                    ].map((status) => {
                                                        return {
                                                            label: status,
                                                            value: status,
                                                            desc: status,
                                                        };
                                                    })}
                                                    optionRender={(option) => (
                                                        <Space>
                                                            <span
                                                                role="img"
                                                                aria-label={
                                                                    option.data
                                                                        .label
                                                                }
                                                            >
                                                                {
                                                                    option.data
                                                                        .emoji
                                                                }
                                                            </span>
                                                            {option.data.desc}
                                                        </Space>
                                                    )}
                                                />
                                            </span>
                                        </div>
                                    </>
                                )}

                                {!editMode && (
                                    <div>Investor Status: {investorStatus}</div>
                                )}
                            </div>

                            <div style={entryStyle}>
                                {editMode && (
                                    <>
                                        <div
                                            style={
                                                isPhoneSize()
                                                    ? {
                                                          display: 'flex',
                                                          flexDirection:
                                                              'column',
                                                      }
                                                    : {
                                                          display: 'flex',
                                                          flexDirection: 'row',
                                                      }
                                            }
                                        >
                                            <div>US Tax Resident Status: </div>
                                            <span>
                                                <Select
                                                    // mode="multiple"
                                                    style={
                                                        isPhoneSize()
                                                            ? {
                                                                  width: '300px',
                                                              }
                                                            : {
                                                                  width: '300px',
                                                                  marginLeft:
                                                                      '5px',
                                                              }
                                                    }
                                                    placeholder="select status"
                                                    value={USTaxResidentStatus}
                                                    onChange={(status) => {
                                                        setDirty(true);
                                                        setUSTaxResidentStatus(
                                                            status
                                                        );
                                                    }}
                                                    options={[
                                                        {
                                                            label: 'US Person',
                                                            value: 'US Person',
                                                            desc: 'US Person',
                                                        },
                                                        {
                                                            label: 'Foreigner',
                                                            value: 'Foreigner',
                                                            desc: 'Foreigner',
                                                        },
                                                    ]}
                                                    optionRender={(option) => (
                                                        <Space>
                                                            <span
                                                                role="img"
                                                                aria-label={
                                                                    option.data
                                                                        .label
                                                                }
                                                            >
                                                                {
                                                                    option.data
                                                                        .emoji
                                                                }
                                                            </span>
                                                            {option.data.desc}
                                                        </Space>
                                                    )}
                                                />
                                            </span>
                                        </div>
                                    </>
                                )}

                                {!editMode && (
                                    <div>
                                        US Tax Resident Status:{' '}
                                        {USTaxResidentStatus}
                                    </div>
                                )}
                            </div>

                            <div
                                style={
                                    isPhoneSize()
                                        ? entryStyle
                                        : { ...entryStyle, display: 'flex' }
                                }
                            >
                                {editMode && (
                                    <>
                                        <div>Address:</div>{' '}
                                        <input
                                            style={inputStyle}
                                            value={address}
                                            onInput={(e) => {
                                                setAddress(e.target.value);
                                                setDirty(true);
                                            }}
                                        ></input>
                                    </>
                                )}
                                {!editMode && viewAddress && (
                                    <>
                                        <div>Address: {address}</div>

                                        <EyeOutlined
                                            style={{
                                                color: 'blue',
                                                marginLeft: '10px',
                                            }}
                                            onClick={(e) =>
                                                setViewAddress(false)
                                            }
                                        />
                                    </>
                                )}

                                {!editMode && !viewAddress && (
                                    <>
                                        <div>
                                            Address:{' '}
                                            {'*'.repeat(address.length)}
                                        </div>
                                        {isAdmin() && (
                                            <EyeInvisibleOutlined
                                                style={{
                                                    color: 'blue',
                                                    marginLeft: '10px',
                                                }}
                                                onClick={(e) =>
                                                    setViewAddress(true)
                                                }
                                            />
                                        )}
                                    </>
                                )}
                            </div>

                            <div style={entryStyle}>
                                {editMode && (
                                    <>
                                        Is DRI:{' '}
                                        <Switch
                                            // className="investment-status-switch"
                                            checkedChildren="Yes"
                                            unCheckedChildren="No"
                                            onChange={
                                                handleIsDRIStatusSwitchChange
                                            }
                                            checked={isDri}
                                        />
                                    </>
                                )}

                                {!editMode && (
                                    <div>Is DRI: {isDri ? 'Yes' : 'No'}</div>
                                )}
                            </div>

                            <div style={entryStyle}>
                                {editMode && (
                                    <>
                                        <div
                                            style={
                                                isPhoneSize()
                                                    ? {
                                                          display: 'flex',
                                                          flexDirection:
                                                              'column',
                                                      }
                                                    : {
                                                          display: 'flex',
                                                          flexDirection: 'row',
                                                      }
                                            }
                                        >
                                            <div>DRI: </div>
                                            <span>
                                                <Select
                                                    style={
                                                        isPhoneSize()
                                                            ? {
                                                                  width: '300px',
                                                              }
                                                            : {
                                                                  width: '300px',
                                                                  marginLeft:
                                                                      '5px',
                                                              }
                                                    }
                                                    placeholder="select dri"
                                                    defaultValue={myDRIDisplay}
                                                    onChange={handleMyDRIChange}
                                                    options={
                                                        driSelectionOptions
                                                    }
                                                    optionRender={(option) => (
                                                        <Space>
                                                            <span
                                                                role="img"
                                                                aria-label={
                                                                    option.data
                                                                        .label
                                                                }
                                                            >
                                                                {
                                                                    option.data
                                                                        .emoji
                                                                }
                                                            </span>
                                                            {option.data.desc}
                                                        </Space>
                                                    )}
                                                />
                                            </span>
                                        </div>
                                    </>
                                )}

                                {!editMode && (
                                    <div style={{}}>
                                        DRI: {myDRI && myDRI.legal_name}
                                    </div>
                                )}
                            </div>

                            <div style={entryStyle}>
                                {editMode && (
                                    <>
                                        <div
                                            style={
                                                isPhoneSize()
                                                    ? {
                                                          display: 'flex',
                                                          flexDirection:
                                                              'column',
                                                      }
                                                    : {
                                                          display: 'flex',
                                                          flexDirection: 'row',
                                                      }
                                            }
                                        >
                                            <div>Referred by: </div>
                                            {referals.length > 0 && (
                                                <span>
                                                    <Select
                                                        style={
                                                            isPhoneSize()
                                                                ? {
                                                                      width: '300px',
                                                                  }
                                                                : {
                                                                      width: '300px',
                                                                      marginLeft:
                                                                          '5px',
                                                                  }
                                                        }
                                                        placeholder="select referral"
                                                        defaultValue={
                                                            myReferralId
                                                                ? `${referralToText(
                                                                      referals.find(
                                                                          (
                                                                              ref
                                                                          ) =>
                                                                              ref.id ===
                                                                              myReferralId
                                                                      )
                                                                  )}`
                                                                : null
                                                        }
                                                        onChange={(e) => {
                                                            setMyReferralId(e);
                                                            setDirty(true);
                                                        }}
                                                        options={referals.map(
                                                            (ref) => {
                                                                return {
                                                                    label: referralToText(
                                                                        ref
                                                                    ),
                                                                    value: ref.id,
                                                                    desc: ref.legal_name,
                                                                };
                                                            }
                                                        )}
                                                        optionRender={(
                                                            option
                                                        ) => (
                                                            <Space>
                                                                <span
                                                                    role="img"
                                                                    aria-label={
                                                                        option
                                                                            .data
                                                                            .label
                                                                    }
                                                                >
                                                                    {
                                                                        option
                                                                            .data
                                                                            .emoji
                                                                    }
                                                                </span>
                                                                {
                                                                    option.data
                                                                        .desc
                                                                }
                                                            </Space>
                                                        )}
                                                    />
                                                </span>
                                            )}
                                        </div>
                                    </>
                                )}

                                {!editMode && (
                                    <div style={{}}>
                                        Referred by:{' '}
                                        {myReferralId
                                            ? `${referralToText(
                                                  referals.find(
                                                      (ref) =>
                                                          ref.id ===
                                                          myReferralId
                                                  )
                                              )}`
                                            : null}
                                    </div>
                                )}
                            </div>

                            <div style={entryStyle}>
                                {editMode && (
                                    <>
                                        <div
                                            style={
                                                isPhoneSize()
                                                    ? {
                                                          display: 'flex',
                                                          flexDirection:
                                                              'column',
                                                      }
                                                    : {
                                                          display: 'flex',
                                                          flexDirection: 'row',
                                                      }
                                            }
                                        >
                                            <div>Investment Entities: </div>
                                            <span>
                                                <Select
                                                    mode="multiple"
                                                    style={
                                                        isPhoneSize()
                                                            ? {
                                                                  width: '300px',
                                                              }
                                                            : {
                                                                  width: '300px',
                                                                  marginLeft:
                                                                      '5px',
                                                              }
                                                    }
                                                    placeholder="select accounts"
                                                    value={accountIdSelected}
                                                    onChange={handleChange}
                                                    options={selectionOptions}
                                                    filterOption={(
                                                        input,
                                                        option
                                                    ) =>
                                                        (option?.label ?? '')
                                                            .toLowerCase()
                                                            .includes(
                                                                input.toLowerCase()
                                                            )
                                                    }
                                                    optionRender={(option) => (
                                                        <Space>
                                                            <span
                                                                role="img"
                                                                aria-label={
                                                                    option.data
                                                                        .label
                                                                }
                                                            >
                                                                {
                                                                    option.data
                                                                        .emoji
                                                                }
                                                            </span>
                                                            {option.data.desc}
                                                        </Space>
                                                    )}
                                                />
                                            </span>
                                        </div>
                                    </>
                                )}
                                {!editMode && (
                                    <div style={{}}>
                                        Investment Entities:
                                        {accountsHeld
                                            .sort((a, b) => {
                                                if (
                                                    a.account_name <
                                                    b.account_name
                                                ) {
                                                    return -1;
                                                }
                                                return 1;
                                            })
                                            .map((account, idx) => {
                                                return (
                                                    <div
                                                        key={idx}
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection:
                                                                'column',
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                // fontSize: "20px",
                                                                // margin: "20px",
                                                                width: 'fit-content',
                                                            }}
                                                        >
                                                            {
                                                                account.account_name
                                                            }
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                    </div>
                                )}
                            </div>

                            {isAdmin() && !saving && (
                                <div
                                    style={{
                                        margin: '20px',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                    }}
                                >
                                    <button
                                        style={{
                                            height: '30px',
                                            width: '50px',
                                            borderRadius: '30px',
                                            background: 'rgb(17 32 86)',
                                            color: 'white',
                                            cursor: 'pointer',
                                        }}
                                        onClick={saveInvestor}
                                    >
                                        Save
                                    </button>
                                    {investor !== null && (
                                        <button
                                            style={{
                                                height: '30px',
                                                width: '70px',
                                                borderRadius: '30px',
                                                background: 'red',
                                                color: 'white',
                                                cursor: 'pointer',
                                            }}
                                            onClick={deleteInvestor}
                                        >
                                            Delete
                                        </button>
                                    )}
                                </div>
                            )}
                            {isAdmin() && saving && (
                                <div style={{ margin: '20px' }}>
                                    <button
                                        style={{
                                            height: '30px',
                                            width: '70px',
                                            borderRadius: '30px',
                                            background: 'rgb(17 32 86)',
                                            color: 'white',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        Saving
                                    </button>
                                </div>
                            )}

                            <div style={entryStyle}>
                                Positions:
                                {/* head */}
                                <PositionTable
                                    currency={'usd'}
                                    sumMethod={sumUSDFormat}
                                />
                                <PositionTable
                                    currency={'cny'}
                                    sumMethod={sumCNYFormat}
                                />
                                {/* <Summary sumMethod={sumAllFormatUSD} /> */}
                            </div>

                            {isDri && manageRecordId > 0 && (
                                <>
                                    <div style={entryStyle}>
                                        DRI Investor Positions:
                                    </div>
                                    <div style={{ marginLeft: '20px' }}>
                                        <InvestorPositionsTable />
                                    </div>
                                </>
                            )}

                            <div style={entryStyle}>
                                Investment Entities:
                                {accountsHeld
                                    .sort((a, b) => {
                                        if (a.account_name < b.account_name) {
                                            return -1;
                                        }
                                        return 1;
                                    })
                                    .map((account, idx) => {
                                        return (
                                            <div
                                                key={idx}
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        // fontSize: "20px",
                                                        // margin: "20px",
                                                        width: 'fit-content',
                                                        color: 'blue',
                                                        textDecoration:
                                                            'underline',
                                                        cursor: 'pointer',
                                                    }}
                                                    onClick={() => {
                                                        setManageRecordId(
                                                            account.id
                                                        );
                                                        setManageRecordTab(
                                                            'Investment Entities'
                                                        );
                                                    }}
                                                >
                                                    {account.account_name}
                                                </div>
                                            </div>
                                        );
                                    })}
                            </div>

                            <div style={entryStyle}>
                                Entities:
                                {fundsByInvestor
                                    .sort((a, b) => {
                                        if (a.name < b.name) {
                                            return -1;
                                        }
                                        return 1;
                                    })
                                    .map((fund, idx) => {
                                        return (
                                            <div
                                                key={idx}
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        // fontSize: "20px",
                                                        // margin: "20px",
                                                        width: 'fit-content',
                                                        color: 'blue',
                                                        textDecoration:
                                                            'underline',
                                                        cursor: 'pointer',
                                                    }}
                                                    onClick={() => {
                                                        setManageRecordId(
                                                            fund.id
                                                        );
                                                        setManageRecordTab(
                                                            'Entities/Funds'
                                                        );
                                                    }}
                                                >
                                                    {fund.name}
                                                </div>
                                            </div>
                                        );
                                    })}
                            </div>

                            {investor !== null && (
                                <>
                                    <div
                                        style={
                                            isPhoneSize()
                                                ? entryStyle
                                                : {
                                                      ...entryStyle,
                                                      display: 'flex',
                                                      flexDirection: 'column',
                                                  }
                                        }
                                    >
                                        Comments:
                                    </div>
                                    <div>
                                        {comments
                                            .sort((a, b) => {
                                                if (a.timestamp < b.timestamp) {
                                                    return -1;
                                                }
                                                return 1;
                                            })
                                            .map((comment, index) => (
                                                <div
                                                    key={index}
                                                    style={commentCardStyle}
                                                >
                                                    <div
                                                        style={
                                                            commentHeaderStyle
                                                        }
                                                    >
                                                        <div>
                                                            <h3
                                                                style={
                                                                    authorStyle
                                                                }
                                                            >
                                                                {comment.email}
                                                            </h3>
                                                            <p
                                                                style={
                                                                    timestampStyle
                                                                }
                                                            >
                                                                {new Date(
                                                                    `${comment.timestamp}Z`
                                                                )
                                                                    .toLocaleString()
                                                                    .replaceAll(
                                                                        '/',
                                                                        '-'
                                                                    )}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <p style={commentTextStyle}>
                                                        {comment.comment}
                                                    </p>
                                                </div>
                                            ))}
                                    </div>
                                </>
                            )}

                            {/* <div style={entryStyle}>
                Holding Companies:
                {companiesByInvestor
                    .sort((a, b) => {
                        if (a.name < b.name) {
                            return -1
                        }
                        return 1
                    })
                    .map((company, idx) => {
                        return <div key={idx} style={{ display: "flex", flexDirection: "row" }}>
                            <div style={{
                                // fontSize: "20px",
                                // margin: "20px",
                                width: "fit-content",
                                color: "blue",
                                textDecoration: "underline",
                                cursor: "pointer"
                            }}
                                onClick={() => {
                                    setManageRecordId(company.id)
                                    setManageRecordTab("Companies")
                                }}>
                                {company.name}
                            </div>
                        </div>
                    })}
            </div> */}

                            {/* <div style={entryStyle}>
                Assets:
                {propertiesByInvestor
                    .sort((a, b) => {
                        if (propertyToAddress(a) < propertyToAddress(b)) {
                            return -1
                        }
                        return 1
                    })
                    .map((property, idx) => {
                        return <div key={idx} style={{ display: "flex", flexDirection: "row" }}>
                            <div style={{
                                // fontSize: "20px",
                                // margin: "20px",
                                width: "fit-content",
                                color: "blue",
                                textDecoration: "underline",
                                cursor: "pointer"
                            }}
                                onClick={() => {
                                    setManageRecordId(property.id)
                                    setManageRecordTab("Assets")
                                }}>
                                {propertyToAddress(property)}
                            </div>
                        </div>
                    })}
            </div> */}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
